"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var omi_1 = require("omi");
var css = require("./index.scss");
var switch_1 = require("@material/switch");
// @ts-ignore
var util_ts_1 = require("../util.ts");
//@ts-ignore
require("../theme.ts");
var Switch = /** @class */ (function (_super) {
    __extends(Switch, _super);
    function Switch() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onInput = function (evt) {
            _this.fire('change', {
                value: _this.props.value,
                checked: _this.switchControl.checked,
                disabled: _this.switchControl.disabled,
                label: _this.props.label
            });
        };
        return _this;
    }
    Switch.prototype.updated = function () {
        this.initSwitch();
    };
    Switch.prototype.installed = function () {
        this.switchControl = new switch_1.MDCSwitch(this.shadowRoot.querySelector('.mdc-switch'));
        this.switchFoundation = this.switchControl.getDefaultFoundation();
        this.initSwitch();
    };
    Switch.prototype.initSwitch = function () {
        if (this.props.checked === true || this.props.checked === 'true') {
            this.switchFoundation.setChecked(true);
        }
        else {
            this.switchFoundation.setChecked(false);
        }
        if (this.props.disabled === true || this.props.disabled === 'true') {
            this.switchFoundation.setDisabled(true);
        }
        else {
            this.switchFoundation.setDisabled(false);
        }
    };
    Switch.prototype.render = function (props) {
        return [
            omi_1.h("div", __assign({}, omi_1.extractClass(props, 'mdc-switch', {
                'mdc-switch--disabled': props.disabled,
                'mdc-switch--checked': props.checked
            })),
                omi_1.h("div", { class: "mdc-switch__track" }),
                omi_1.h("div", { class: "mdc-switch__thumb-underlay" },
                    omi_1.h("div", { class: "mdc-switch__thumb" },
                        omi_1.h("input", __assign({}, util_ts_1.extract(props, ['value']), { type: "checkbox", id: "basic-switch", class: "mdc-switch__native-control", role: "switch", onClick: this.onInput }))))),
            omi_1.h("label", { for: "basic-switch" },
                "\u00A0",
                props.label)
        ];
    };
    Switch.css = css;
    Switch.propTypes = {
        label: String,
        disabled: Boolean,
        checked: Boolean,
        value: String
    };
    Switch.defaultProps = {};
    Switch = __decorate([
        omi_1.tag('m-switch')
    ], Switch);
    return Switch;
}(omi_1.WeElement));
exports.default = Switch;
